import { all, put, call, takeEvery, select } from 'redux-saga/effects'
import { apiPaths } from '../../config'
import { http } from '../../services'
import { getDocumentFromS3 } from '../clinicPatient/sagas'
import { billingEligibilitySetState as setState } from '../actions'
import billingEligibilityAction from './actions'

const getUser = (state) => state.user

const getEligibilityLogs = async (data, role) =>
  http
    .get(apiPaths[role].apiEligibilityLogs, data)
    .then((res) => res)
    .catch(() => [])

const getDevices = async (data, role) =>
  http
    .get(apiPaths[role].apiReportDevices, data)
    .then((res) => res)
    .catch(() => [])

const getPatients = async (data, role) =>
  http
    .get(apiPaths[role].apiReportPatients, data)
    .then((res) => res)
    .catch(() => [])

export function* GET_VALUES_FOR_DROPDOWN({ payload }) {
  yield put(setState({ dropDownLoading: true, devices: [], patients: [] }))
  const { role } = yield select(getUser)
  const devices = yield call(getDevices, payload, role)
  const patients = yield call(getPatients, payload, role)
  yield put(setState({ dropDownLoading: false, devices, patients }))
}

export function* GET_ELIGIBILITY_LOGS_LIST({ payload }) {
  const { report } = payload
  let payloadToReload = {}
  if (report === 'eligibility') {
    payloadToReload = {
      eligibilityReportList: [],
    }
  } else {
    payloadToReload = {
      eligibilityLogsList: [],
    }
  }
  yield put(setState({ loading: true, ...payloadToReload }))

  const { role } = yield select(getUser)
  const response = yield call(getEligibilityLogs, payload, role)

  let payloadToBeSent = {}

  if (report === 'eligibility') {
    response.map((item) => {
      const responseFile = getDocumentFromS3('clinicPatient', item.information_file).then(
        (result) => result,
      )
      responseFile.then((result) => {
        item.fileLink = result
        return item
      })
      return false
    })
    payloadToBeSent = {
      eligibilityReportList: response,
      loading: false,
    }
  } else {
    payloadToBeSent = {
      eligibilityLogsList: response,
      loading: false,
    }
  }
  yield put(setState({ payloadToBeSent }))
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(billingEligibilityAction.GET_ELIGIBILITY_LOGS_LIST, GET_ELIGIBILITY_LOGS_LIST),
    takeEvery(billingEligibilityAction.GET_VALUES_FOR_DROPDOWN, GET_VALUES_FOR_DROPDOWN),
  ])
}
